import { TypeOf, yup } from '@guiker/shared-framework'

import { accountHolderSchema } from './account-holder'

export const updateAccountHolderSchema = yup.object({
  accountHolder: accountHolderSchema.required(),
})

export type UpdateAccountHolderSchema = TypeOf<typeof updateAccountHolderSchema>
